import { addMorphDelta, skinVertexToRef } from './deformation-math.js';

function captureDeformPose(mesh) {
  const skeleton = mesh.skeleton;
  const morph = mesh.morphTargets;
  if (!skeleton && !morph) {
    return null;
  }
  return {
    boneMatrices: skeleton ? new Float32Array(skeleton.boneMatrices) : null,
    morphWeights: morph ? new Float32Array(morph.weights) : null
  };
}
function captureDeformPoses(candidates) {
  const poses = /* @__PURE__ */ new Map();
  for (const { mesh } of candidates) {
    const pose = captureDeformPose(mesh);
    if (pose) {
      poses.set(mesh, pose);
    }
  }
  return poses;
}
function deformerFor(poses, mesh) {
  const pose = poses?.get(mesh) ?? null;
  return pose ? (m, i0, i1, i2, out) => deformTriangleToRef(m, i0, i1, i2, out, pose) : null;
}
let _deformScratch;
function computeDeformedPositionToRef(mesh, vertexIndex, out) {
  return deformVertexToRef(mesh, vertexIndex, out, null);
}
function deformVertexToRef(mesh, vertexIndex, out, pose) {
  const base = mesh._cpuPositions;
  if (!base) {
    return false;
  }
  const componentOffset = vertexIndex * 3;
  if (componentOffset < 0 || componentOffset + 2 >= base.length) {
    return false;
  }
  const scratch = _deformScratch ??= new Float32Array(3);
  scratch[0] = base[componentOffset];
  scratch[1] = base[componentOffset + 1];
  scratch[2] = base[componentOffset + 2];
  const morph = mesh.morphTargets;
  if (morph) {
    addMorphDelta(morph, scratch, 0, componentOffset, pose?.morphWeights);
  }
  const skeleton = mesh.skeleton;
  if (skeleton) {
    skinVertexToRef(
      pose?.boneMatrices ?? skeleton.boneMatrices,
      skeleton.joints,
      skeleton.weights,
      skeleton.joints1,
      skeleton.weights1,
      vertexIndex,
      scratch[0],
      scratch[1],
      scratch[2],
      1,
      scratch,
      0
    );
  }
  out.x = scratch[0];
  out.y = scratch[1];
  out.z = scratch[2];
  return true;
}
let _triangleVertex;
function writeDeformedVertex(mesh, vertexIndex, out, offset, pose) {
  const vertex = _triangleVertex ??= { x: 0, y: 0, z: 0 };
  if (!deformVertexToRef(mesh, vertexIndex, vertex, pose)) {
    return false;
  }
  out[offset] = vertex.x;
  out[offset + 1] = vertex.y;
  out[offset + 2] = vertex.z;
  return true;
}
function deformTriangleToRef(mesh, i0, i1, i2, out, pose = null) {
  return writeDeformedVertex(mesh, i0, out, 0, pose) && writeDeformedVertex(mesh, i1, out, 3, pose) && writeDeformedVertex(mesh, i2, out, 6, pose);
}

export { captureDeformPose, captureDeformPoses, computeDeformedPositionToRef, deformTriangleToRef, deformerFor };
//# sourceMappingURL=deformed-vertex.js.map
